<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent custom-100">
        <b-row>
            <b-col>
                <div style=" padding: 5px 10px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <div  style="padding-right: 8px; padding-left: 15px">
                            <b-dropdown text="Filter">
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.commune">Kommune</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.tour">Tour</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.city">Ort</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.district">Ortsteil</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.area">Gebiet</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                <b-form-checkbox class="mb-3" v-model="active_filters.object_location">Objektstandort</b-form-checkbox>
                            </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.location">Stand</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.search">Baumnummer</b-form-checkbox>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                        <b-col md="2" v-if="active_filters.commune === true">
                            <b-form-select class="black" plain
                                           :options="filters.commune"
                                           v-model="filter_selects.commune">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Kommune auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.tour === true">
                            <b-form-select class="black" plain
                                           :options="filters.tour"
                                           v-model="filter_selects.tour">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Tour auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.city === true">
                            <b-form-select class="black" plain
                                           :options="filters.city"
                                           v-model="filter_selects.city">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Ort auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.district === true">
                            <b-form-select class="black" plain
                                           :options="filters.district"
                                           v-model="filter_selects.district">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Ortsteil auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.area === true">
                            <b-form-select class="black" plain
                                           :options="filters.area"
                                           v-model="filter_selects.area">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Gebiet auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.object_location === true">
                            <b-form-select class="black" plain
                                           :options="filters.object_location"
                                           v-model="filter_selects.object_location">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Objektstandort auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.location === true">
                            <b-form-select class="black" plain
                                           :options="filters.location"
                                           v-model="filter_selects.location">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Stand auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.search === true">
                            <b-form-input class="black" v-model="filter_selects.search" type="text" placeholder="Baumnummer">
                            </b-form-input>
                        </b-col>
                        <!--b-col md="2">
                            <b-form-input class="black" v-model="search" type="number" placeholder="Baumnummer">
                            </b-form-input>
                        </b-col>
                        <b-col xl="2" lg="3" md="4" sm="4">
                            <b-button variant="primary" class="px-4" v-on:click="onSearch">Suchen
                            </b-button>
                        </b-col-->
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <b-card no-body style="border: none; height: 100%; margin: 0;">
                    <b-table striped bordered hover responsive id="my-table"
                             class="custom-auto-height" no-local-sorting
                             :fields="fields" :items="items">
                        <template v-slot:head(tree_number)="data">
                            <div v-bind:class="class_sorting.tree_number" v-on:click="changeSorting('tree_number')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(tree_type_ger)="data">
                            <div v-bind:class="class_sorting.tree_type_ger" v-on:click="changeSorting('tree_type_ger')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(tree_type_bot)="data">
                            <div v-bind:class="class_sorting.tree_type_bot" v-on:click="changeSorting('tree_type_bot')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(growing_state)="data">
                            <div v-bind:class="class_sorting.growing_state" v-on:click="changeSorting('growing_state')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(verkehrssicher)="data">
                            <div v-bind:class="class_sorting.verkehrssicher" v-on:click="changeSorting('verkehrssicher')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(condition)="data">
                            <div v-bind:class="class_sorting.condition" v-on:click="changeSorting('condition')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(vitality_status)="data">
                            <div v-bind:class="class_sorting.vitality_status" v-on:click="changeSorting('vitality_status')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(security_expectation)="data">
                            <div v-bind:class="class_sorting.security_expectation" v-on:click="changeSorting('security_expectation')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(time_to_live)="data">
                            <div v-bind:class="class_sorting.time_to_live" v-on:click="changeSorting('time_to_live')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(planting_year)="data">
                            <div v-bind:class="class_sorting.planting_year" v-on:click="changeSorting('planting_year')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(action_required)="data">
                            <div v-bind:class="class_sorting.action_required" v-on:click="changeSorting('action_required')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(next_control)="data">
                            <div v-bind:class="class_sorting.next_control" v-on:click="changeSorting('next_control')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>
                        <template v-slot:head(last_control)="data">
                            <div v-bind:class="class_sorting.last_control" v-on:click="changeSorting('last_control')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(commune)="data">
                            <div v-bind:class="class_sorting.commune" v-on:click="changeSorting('commune')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(tour)="data">
                            <div v-bind:class="class_sorting.tour" v-on:click="changeSorting('tour')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(city)="data">
                            <div v-bind:class="class_sorting.city" v-on:click="changeSorting('city')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(district)="data">
                            <div v-bind:class="class_sorting.district" v-on:click="changeSorting('district')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(area)="data">
                            <div v-bind:class="class_sorting.area" v-on:click="changeSorting('area')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(object_location)="data">
                            <div v-bind:class="class_sorting.object_location" v-on:click="changeSorting('object_location')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(location)="data">
                            <div v-bind:class="class_sorting.location" v-on:click="changeSorting('location')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(function)="data">
                            <div v-bind:class="class_sorting.function" v-on:click="changeSorting('function')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(tree_height)="data">
                            <div v-bind:class="class_sorting.tree_height" v-on:click="changeSorting('tree_height')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(crown_mean)="data">
                            <div v-bind:class="class_sorting.crown_mean" v-on:click="changeSorting('crown_mean')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(trunk_count)="data">
                            <div v-bind:class="class_sorting.trunk_count" v-on:click="changeSorting('trunk_count')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:head(trunk_diameter)="data">
                            <div v-bind:class="class_sorting.trunk_diameter" v-on:click="changeSorting('trunk_diameter')" style="width: 100%;">{{data.label}}
                            </div>
                        </template>

                        <template v-slot:cell(open)="data">
                            <open-icon  v-on:click="openTree(data.item.tree_id)"
                                        class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                        style="color: green"></open-icon>
                        </template>
                    </b-table>
                    <div class="mt-3 custom-flex-0">
                        <b-pagination align="center"
                                      v-model="currentPage"
                                      :per-page="perPage"
                                      :total-rows="totalItems"></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';


    export default {
        name: "trees",
        components: {
          OpenIcon
        },
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/trees/filter'
            ).then(this.responseOkGetFilter, this.responseError)
        },
        data: () => {
            return {
                loader: undefined,
                currentPage: 1,
                perPage: 20,
                totalItems: 5000,
                items: [],
                wasMounted: false,
                fields: [
                    /*{key: 'tree_number', label: "Baumnummer"},
                    {key: 'verkehrssicher', label: "Verkehrssicherheit"},
                    {key: 'vitality_status', label: "Vitalität"},
                    {key: 'next_control', label: "Nächste Kontrolle"},
                    {key: 'last_control', label: "Letzte Kontrolle"},
                    {key: 'action_required', label: "Maßnahme erforderlich"},
                    {key: 'growing_state', label: "Entwicklungsphase"},
                    {key: 'security_expectation', label: "Sicherheitserwartung"},
                    {key: 'condition', label: "Zustand"},
                    {key: 'open', label: ""},*/
                ],
                class_sorting: {
                    tree_number: "sortingasc",
                    tree_type_ger: "sortingnone",
                    tree_type_bot: "sortingnone",
                    growing_state: "sortingnone",
                    verkehrssicher: "sortingnone",
                    condition: "sortingnone",
                    vitality_status: "sortingnone",
                    security_expectation: "sortingnone",
                    time_to_live: "sortingnone",
                    planting_year: "sortingnone",
                    action_required: "sortingnone",
                    next_control: "sortingnone",
                    last_control: "sortingnone",
                    commune: "sortingnone",
                    tour: "sortingnone",
                    city: "sortingnone",
                    district: "sortingnone",
                    area: "sortingnone",
                    object_location: "sortingnone",
                    location: "sortingnone",
                    function: "sortingnone",
                    tree_height: "sortingnone",
                    crown_mean: "sortingnone",
                    trunk_count: "sortingnone",
                    trunk_diameter: "sortingnone",
                },
                nextSorting: {
                    sortingnone: "sortingasc",
                    sortingasc: "sortingdesc",
                    sortingdesc: "sortingnone"

                },
                currentSortings: ["tree_number_asc"],
                search: "",
                filters: {
                },
                active_filters: {
                    commune: false,
                    tour: true,
                    city: true,
                    district: false,
                    area: false,
                    object_location: true,
                    location: false,
                    search: false,
                },
                filter_selects: {
                    commune: null,
                    tour: null,
                    city: null,
                    district: null,
                    area: null,
                    object_location: null,
                    location: null,
                    search: null,
                }
            }
        },
        watch: {
            currentPage: {
                handler: function(value) {
                  if (this.wasMounted) {
                    this.fetchData();
                  }
                }
            },
          active_filters: {
                handler(val){
                    if (this.wasMounted) {
                        this.setQuery();
                    }
                },
                deep: true
            },
          filter_selects: {
            handler(val){
              if (this.wasMounted) {
                this.onSearch();
              }
            },
            deep: true
          }
        },
        methods: {
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGetFilter(response) {
                if (response.status === 200) {
                    this.filters = response.data;
                    for (let i = 0; i < this.filters.table_options_trees.length; i++) {
                        let item = this.filters.table_options_trees[i];
                        this.fields.push({key: item.s_value_1, label: item.s_value});
                    }
                    this.fields.push({key: 'open', label: ""});
                    this.parseQuery();
                    this.$nextTick(() => {
                        this.fetchData();
                    });
                    //this.fetchData();
                } else {
                    console.log(response);
                }
            },

            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.totalItems = response.data.count;
                    this.items = response.data.trees;
                } else {
                    console.log(response);
                }
            },
            onSearch() {
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            changeSorting(field) {
                this.class_sorting[field] = this.nextSorting[this.class_sorting[field]];
                if (this.class_sorting[field] === "sortingasc") {
                    this.currentSortings.push(field+"_asc")
                } else if (this.class_sorting[field] === "sortingdesc") {
                    for (let i = 0; i < this.currentSortings.length; i++) {
                        if (this.currentSortings[i].startsWith(field)) {
                            this.currentSortings[i] = field+"_desc";
                            break;
                        }
                    }
                } else {
                    for (let i = 0; i < this.currentSortings.length; i++) {
                        if (this.currentSortings[i].startsWith(field)) {
                            this.currentSortings.splice(i,1)
                            break;
                        }
                    }
                }
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            getQuery() {
                let query = "?limit="+this.perPage;
                query += "&page="+(this.currentPage-1);
                for (let i = 0; i < this.currentSortings.length; i++) {
                    query += "&sorting[]="+this.currentSortings[i];
                }
                for (let param in this.active_filters) {
                    if (this.active_filters[param] === true && this.filter_selects[param] !== null) {
                        query += "&"+param+"="+encodeURIComponent(this.filter_selects[param]);
                    }
                }
                this.setQuery();
                return query;
            },
            fetchData() {
                this.wasMounted = true;
                this.showLoader();
                this.$http.get(
                    Server_URL + '/baumkontrolle/trees'+this.getQuery()
                ).then(this.responseOkGet, this.responseError)
            },
            openTree(id) {
                let routeData = this.$router.resolve({name: 'Baum', params: {id: id}});
                this.$router.push("/tree/show/"+id);
            },
            parseQuery() {
              let query = this.$route.query;
              if (query.limit !== undefined) {
                  this.perPage = parseInt(query.limit);
              }
              if (query.page !== undefined) {
                  this.currentPage = parseInt(query.page)+1;
              }
              if (query.sorting !== undefined) {
                  if (typeof query.sorting === "string") {
                      query.sorting = [query.sorting];
                  }
                  this.currentSortings = query.sorting;
                  for (let i = 0; i < this.currentSortings.length; i++) {
                    // split on the last _
                    let pos = this.currentSortings[i].lastIndexOf('_');
                      let field = this.currentSortings[i].substring(0,pos);
                      let sort = this.currentSortings[i].substring(pos+1);
                      this.class_sorting[field] = "sorting"+sort;
                  }
              }
              if (query.page !== undefined) {
                for (let param in this.active_filters) {
                  this.active_filters[param] = query[param+"_active"] === "true";
                  if (query[param + "_filter"] !== undefined) {
                    this.filter_selects[param] = query[param + "_filter"];
                  }
                }
              }
            },
            setQuery() {
              let query = {
                limit: this.perPage,
                page: this.currentPage-1,
                sorting: [...this.currentSortings],

              }
              let active_filters = [];
              for (let param in this.active_filters) {
                  if (this.active_filters[param] === true) {
                      query[param+"_active"] = "true";
                  }
              }
              query.active_filters = active_filters;
              for (let param in this.filter_selects) {
                  if (this.filter_selects[param] !== null) {
                      query[param + "_filter"] = this.filter_selects[param];
                  }
              }
              this.$router.push({query: query}).then(() => {}).catch(err => {});
            }
        }
    }
</script>

<style>

    .black {
        color: #23282c;
    }

    .custom-100 {
        height: 100%;
        display: flex;
        flex-direction: column;
        -ms-flex-direction: column;
        -webkit-flex-direction: column;
    }

    .custom-flex-1 {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
    }

    .custom-auto-height {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
        max-height: 100%;
    }

    .custom-flex-0 {
        flex: 0;
        -moz-box-flex: 0;
        -ms-flex: 0;
        -webkit-flex: 0;
    }

    .sortingnone {
        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    .sortingdesc {

        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    .sortingasc {

        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }
</style>

<style scoped>

    .hoverable-icon:hover {
        cursor: pointer;
    }
</style>
